import { Pipe, PipeTransform } from '@angular/core';
import * as vkbeautify from 'vkbeautify';

@Pipe({
    name: 'prettyPrintXml',
    standalone: false
})
export class PrettyPrintXmlPipe implements PipeTransform {
    transform(xml: string): string {
        return vkbeautify.xml(xml);
    }
}
